import React, { useContext, useState } from 'react';
import {
  CardHeader,
  CardHeaderSubtitle,
  CardHeaderText,
  CardHeaderTitle
} from 'components/card/card-header';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'messages';
import { Button } from 'components/button';
import Icon from 'components/icon/Icon';
import { Card, CardBody, CardFooter } from 'components/card';
import List from 'components/list/List';
import ListBody from 'components/list/ListBody';
import {
  ListItem,
  ListItemLabel,
  ListItemLabelWrapper
} from 'components/list/list-item';
import { format } from 'date-fns';
import formatDistance from 'date-fns/formatDistance';
import AddInjuryModal from 'containers/pages/rehab/injury/AddInjuryModal';
import { calculateInjuriesSubtitle } from 'utils/date';
import { useMedicalContext } from 'contexts/MedicalContext';
import { StoreContext } from 'index';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_DETAIL } from 'routes/RouteList';
import { DATE_LOCALE, PersonInjuryType } from 'constants.js';
import Badge from 'components/badge/Badge';
import { useEntityContext } from 'containers/pages/persons/store/useEntityContext';

const SporterMedicalInjuries = () => {
  const { entityId, groupId, injuryId } = useParams();
  const intl = useIntl();
  const { push } = useHistory();
  const {
    uiState: { locale }
  } = useContext(StoreContext);
  const person = useEntityContext(s => s.person);
  const { medical } = useMedicalContext();
  const defaultListLength = 10;
  const [injuriesListCount, setInjuriesListCount] = useState(defaultListLength);
  const [injuryModal, setInjuryModal] = useState(false);

  const onClickInjuryHandler = injury => {
    push(
      generatePath(ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_DETAIL, {
        entityId,
        groupId,
        personId: person.id,
        medicalId: medical.id,
        injuryId: injury.id
      })
    );
  };

  return (
    <Card reports>
      <CardHeader secondary>
        <CardHeaderText>
          <CardHeaderTitle>
            <FormattedMessage {...messages.titleInjuries} />
          </CardHeaderTitle>
          <CardHeaderSubtitle>
            {calculateInjuriesSubtitle(
              medical?.injuries,
              locale,
              intl,
              PersonInjuryType.INJURY
            )}
          </CardHeaderSubtitle>
        </CardHeaderText>
        <Button rounded primary onClick={() => setInjuryModal(true)}>
          <Icon id="add-white" />
          <FormattedMessage {...messages.buttonAddInjury} />
        </Button>
      </CardHeader>
      <CardBody secondary>
        <List>
          <ListBody>
            {medical?.injuries &&
              medical.injuries.length > 0 &&
              medical.injuries.slice(0, injuriesListCount).map(personInjury => (
                <ListItem
                  small
                  key={personInjury.id}
                  active={personInjury.id === injuryId}
                  onClick={() => onClickInjuryHandler(personInjury)}
                >
                  <ListItemLabelWrapper>
                    <ListItemLabel label>
                      {personInjury.injury.title}

                      {personInjury.sides &&
                        Object.entries(personInjury.sides).length > 0 &&
                        Object.entries(personInjury.sides).some(e => e[1]) && (
                          <Badge lighterFont>
                            <FormattedMessage
                              {...messages.leftRightBadge}
                              values={{
                                sides:
                                  Object.entries(personInjury.sides).length >
                                    1 &&
                                  Object.entries(personInjury.sides).every(
                                    e => e[1]
                                  )
                                    ? 'both'
                                    : Object.entries(personInjury.sides).find(
                                        e => e[1]
                                      )[0]
                              }}
                            />
                          </Badge>
                        )}
                    </ListItemLabel>
                    {personInjury.injuryEndDate ? (
                      <ListItemLabel
                        label
                        extraClassNames="u-padding-none u-margin-left-auto"
                        style={{ alignSelf: 'center' }}
                      >
                        {formatDistance(
                          personInjury.injuryDate,
                          personInjury.injuryEndDate,
                          { locale: DATE_LOCALE[locale] }
                        )}{' '}
                        - {format(personInjury.injuryDate, 'yyyy')}
                      </ListItemLabel>
                    ) : (
                      <ListItemLabel
                        label
                        extraClassNames="u-padding-none u-margin-left-auto"
                        style={{ alignSelf: 'center' }}
                      >
                        {format(personInjury.injuryDate, 'yyyy')}
                      </ListItemLabel>
                    )}
                  </ListItemLabelWrapper>
                </ListItem>
              ))}
          </ListBody>
        </List>
      </CardBody>
      <CardFooter>
        {medical?.injuries && medical.injuries.length > defaultListLength && (
          <Button
            rounded
            grey
            onClick={() => {
              setInjuriesListCount(
                injuriesListCount ? undefined : defaultListLength
              );
            }}
          >
            <Icon id="dropdown-closed" />
            <FormattedMessage
              {...messages.buttonShowInjuries}
              values={{
                showAll: Boolean(injuriesListCount)
              }}
            />
          </Button>
        )}
      </CardFooter>

      {injuryModal && (
        <AddInjuryModal
          entityId={entityId}
          personId={person.id}
          onClose={() => {
            setInjuryModal(false);
          }}
        />
      )}
    </Card>
  );
};

export default SporterMedicalInjuries;
